import { z } from "zod";

import { InviteFormSchema } from "./invite-user";

// `linkedinAllowed` is an invite-only field: the sending seat is toggled through its own endpoint
// (`PATCH /users/:id/linkedin-allowed`, which also tears down campaigns on revoke), never through
// the edit-user form. Letting it through would also widen `UpdateUser`'s value union past string.
export const UpdateUserFormSchema = InviteFormSchema.omit({ linkedinAllowed: true }).partial();
export const UpdateLinkedinSettingsFormSchema = z.object({
	visitsPerDay: z.number().optional(),
	connectionRequestsPerDay: z.number().optional(),
	messagesPerDay: z.number().optional(),
	autoWithdrawInvitesEnabled: z.boolean().optional(),
	autoWithdrawInvitesDays: z.union([z.literal(30), z.literal(40), z.literal(50)]).optional(),
});

export const UpdateUserSchema = UpdateUserFormSchema.omit({ roles: true, companyId: true });

export type UpdateUserForm = z.infer<typeof UpdateUserFormSchema>;
export type UpdateLinkedinSettingsForm = z.infer<typeof UpdateLinkedinSettingsFormSchema>;
export type UpdateUser = z.infer<typeof UpdateUserSchema>;

export const UpdateUserRolesSchema = z.object({
	roles: z.array(z.object({ id: z.number().gt(0) })),
});

export type UpdateUserRoles = z.infer<typeof UpdateUserRolesSchema>;
